import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { EntityLinksCard } from '@backstage/plugin-catalog';
import { EntityProvider, useEntity } from '@backstage/plugin-catalog-react';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { observabilityLinks, otherLinks } from './links';

/**
 * The observability card, on any entity that carries links typed
 * grafana / sentry / logs — which catalog-etl writes from a service's
 * `spec.observability`.
 */
const EntityObservabilityCard = EntityCardBlueprint.make({
  name: 'observability',
  params: {
    type: 'info',
    filter: entity => observabilityLinks(entity).length > 0,
    loader: () =>
      import('./ObservabilityCard').then(m => <m.ObservabilityCard />),
  },
});

/**
 * The stock Links card reads `metadata.links` whole, so without this every
 * observability link would be drawn twice. It is the catalog's own
 * `entity-card:catalog/links` with the observability links taken out of the
 * entity it sees, and hidden when nothing else is left.
 */
function OtherLinksCard() {
  const { entity } = useEntity();
  return (
    <EntityProvider
      entity={{
        ...entity,
        metadata: { ...entity.metadata, links: otherLinks(entity) },
      }}
    >
      <EntityLinksCard />
    </EntityProvider>
  );
}

const linksCard = catalogPlugin
  .getExtension('entity-card:catalog/links')
  .override({
    params: {
      filter: entity => otherLinks(entity).length > 0,
      loader: async () => <OtherLinksCard />,
    },
  });

export const observabilityModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [EntityObservabilityCard, linksCard],
});
